import React, { useContext } from 'react';
import { CommonStepId } from '../../shared/constants';
import { useStepsContextValue } from './hooks/useStepsContextValue';
import { StepsContextValue, StepsContextProps } from './StepsContext.types';

const createContext = <T extends CommonStepId>() => React.createContext<StepsContextValue<T> | undefined>(undefined);

export const createStepsContextProvider = <T extends CommonStepId>() => {
    const StepsContext = createContext<T>();

    const useStepsContext = (): StepsContextValue<T> => {
        const context = useContext(StepsContext);

        if (context === undefined) {
            throw new Error('useStepsContext must be used within a StepsContextProvider');
        }

        return context;
    };

    const StepsContextProvider = ({ children, stepId, onStepIdChange = () => null }: StepsContextProps<T>) => {
        const contextValue = useStepsContextValue<T>({
            stepId,
            onStepIdChange,
        });

        return <StepsContext.Provider value={contextValue}>{children}</StepsContext.Provider>;
    };
    return {
        useStepsContext,
        StepsContextProvider,
    };
};
